import { normalizeFieldText } from '~/composables/useCustomFields'

function ensureAbsoluteUrl(input: string, fallback: string) {
  const value = String(input || '').trim()
  if (!value) {
    return fallback
  }
  if (/^https?:\/\//i.test(value)) {
    return value.replace(/\/+$/, '')
  }
  return `https://${value.replace(/^\/+/, '').replace(/\/+$/, '')}`
}

export function resolveSiteBaseUrl(fields?: Record<string, unknown>) {
  const runtimeConfig = useRuntimeConfig()
  const fallback = ensureAbsoluteUrl(String(runtimeConfig.public.siteUrl || ''), '')
  const configured = normalizeFieldText(fields, 'siteUrl', '')
  return ensureAbsoluteUrl(configured, fallback)
}
